<template>
    <div style="min-height: 400px;">
            <b-table :items="items" :fields="table.fields" :select-mode="table.selectMode" responsive="sm" primary-key="id" 
                :tbody-transition-props="table.transProps" sort-icon-left
                per-page="50" current-page="1" :busy="table.isBusy" hover striped style="min-height: 200px;">

                <template v-slot:cell(itemDiscount)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.discount"
                    readonly
                    ></b-form-input>
                </template>

                <template v-slot:cell(paymentDate)="data">
                    {{ $utils.localDate(data.item.dueDate) }}
                </template>


                <template v-slot:cell(totalValue)="data">
                    R$ {{ $utils.numberFormat(data.item.totalValue - (data.item.paymentValue ? data.item.paymentValue : 0)) }}
                </template>

              
            </b-table>
       
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";

export default {
    name: 'dashboardGridComponent',
    props: {
        items: []
    },
    watch: {     
        
    },
    components: {
    },
    data: () => {
        return {

            table: {
                fields: [
                    { key: 'description', label: 'Conta', sortable: true },
                    { key: 'paymentDate', label: 'Data', sortable: true, thStyle: { width: "120px" }, tdClass: 'text-center' },
                    { key: 'totalValue', label: 'Valor', thStyle: { width: "120px" }, tdClass: 'text-right' }
                   
                    //{ key: 'quantity', label: 'Quantidade', thStyle: { width: "120px" } },
                    //{ key: 'itemDiscount', label: 'Desconto', sortable: false, thStyle: { width: "120px" } },
                    //{ key: 'totalValue', label: 'Valor Total', thStyle: { width: "120px" }, tdClass: 'text-right' }
                    //{ key: 'description', label: 'Descrição', sortable: true},
                    //{ key: 'action2', label: '', sortable: false, thStyle: { width: "40px" } },                    
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                }

            },
            
        }
    },
    computed: {

    },
    methods: {
        
        async getPayments() {
            var s = this;

            if(s.accountId) {
                var currentUser = this.$store.state.currentUser;

                var url = this.$store.state.ws_url + "/finance/ap/payment?accountId=" + s.accountId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                if(s.accountType == 'R') {
                    url = this.$store.state.ws_url + "/finance/ar/payment?accountId=" + s.accountId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                }

                await axios.get(
                    url
                ).then(function(resp) {
                    s.items = resp.data.obj;
                    s.getPaymentsTotal();

                }).catch(function (error) {
                    console.log(error);
                    s.items = []
                });
            }
            
        },

        refreshData() {
            //this.getPayments()
        }
    }

}

</script>